export default __webpack_public_path__ + "static/media/angle-left.ce2a9c7f.svg";